import { NominationStatus } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNominationStatus: (
  fetchContext: FetchContext,
  nominationId: number,
  nominationStatus: NominationStatus,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, nominationStatus, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/status`, {
    method: 'PUT',
    body: JSON.stringify(nominationStatus),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update nomination status'));
